module.exports = __webpack_public_path__ + "img/new_card_barcode.e7136119.png";